/* import __COLOCATED_TEMPLATE__ from './direct-deposit-info-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();